import { TealiumBaseEvent } from './TealiumBaseEvent';

export class TealiumAddtoWishListEvent extends TealiumBaseEvent {
  static readonly ADD_TO_WISHLIST_EVENT = 'add_to_list';

  constructor() {
    super(TealiumAddtoWishListEvent.ADD_TO_WISHLIST_EVENT, TealiumBaseEvent.EVENT_CATEGORY_DEFAULT, TealiumAddtoWishListEvent.ADD_TO_WISHLIST_EVENT);
    this.setEventLabel('whishlist');
    this.product_keys = [...this.product_keys, 'product_attributes_position'];
    this.uTagInfoMap = this.buildUTagProductInfoMap();
  }
}
